import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import women from "../../images/login-women.png";
import LogoImage from "../../images/SBM.svg";
import NoIndex from "../NoIndex";
import "./Login.css";
import MyContext from "../../MyContext";
import GoogleOneTap from "../Googleonetab";

const LoginPage = () => {
  const { baseUrl, config, config2 } = useContext(MyContext);
  const [location, setLocation] = useState({ latitude: null, longitude: null });
  const [error, setError] = useState(null);
  const [MobileNumber, setMobileNumber] = useState("");
  const [password, setPassword] = useState("");
  const [MobileNumberError, setMobileNumberError] = useState("");
  const [Otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [step, setstep] = useState(1);
  const [OTPField, setOTPField] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const navigate = useNavigate();
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [Lerror, setLerror] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [LoginScreen, setLoginScreen] = useState("LOGIN");


  const [User, setUser] = useState("no user");

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
function validateInputs() {
  if (MobileNumber.length !== 10) {
    toast.error("Invalid Mobile number");
  } else if (!password) {
    toast.error("Please enter your password");
  } else {
    LoginCall();
  }
}

  // Function to send OTP (step 1)
  const sendOtp = async () => {
    try {

      const BankData = {
        mobile: MobileNumber,
        password: password,
        step: "1", // step 1 for sending OTP
        otp: "",   // OTP is empty for step 1
        latitude: '',
        longitude: '',
      };

      // Send OTP request
      const response = await axios.post(
        `${baseUrl}/api/User/v1/userLogin`,
        BankData,
        config2
      );

      if (response.data.responseCode === "00") {
        toast.success(response.data.responseMessage); // OTP sent successfully
        setLoginScreen("OTPVERIFICATION");
        setstep(2); // Move to step 2 (OTP verification)
        setOTPField(true); // Enable OTP input field
      } else if (response.data.responseCode === "01") {
        toast.error(response.data.responseMessage); // OTP sent successfully
        setError(true)
      } else {
        toast.error(response.data.responseMessage); // Handle any error message
      }
    } catch (error) {
      toast.error("Error sending OTP");
      console.error("Error sending OTP:", error);
    }
  };

  // Function to verify OTP (step 2)
  const verifyOtp = async () => {
    try {


      const BankData = {
        mobile: MobileNumber,
        password: password,
        step: "2", // step 2 for OTP verification
        otp: Otp.join(""), // User's entered OTP
        latitude: '',
        longitude: '',
      };

      // Verify OTP request
      const response = await axios.post(
        `${baseUrl}/api/User/v1/userLogin`,
        BankData,
        config2
      );


      if (response.data.responseCode === "00") {
        sessionStorage.setItem("user", JSON.stringify(response.data.response));
        setUser(true);
        console.log("responseData:", response.data.response.userid);
        // await verifyCredentials(responseData.response.userid);
        await subscriptionDetailsApi(response.data.response.userid);
        await allowedServicesAPI(response.data.response.userid);
        window.location.href = "/Dashboard";
      }
      else {
        toast.error(response.data.responseMessage)
      }
    } catch (error) {
      toast.error("Error verifying OTP");
      console.error("Error during OTP verification:", error);
    }
  };

  const allowedServicesAPI = async (userId) => {
    try {
      const requestBody = { userid: userId };
      const response = await axios.post(
        `${baseUrl}/api/User/getUserAccess`,
        requestBody,
        config
      );
      if (response.data.responseCode === "00") {
        sessionStorage.setItem(
          "menuItems",
          JSON.stringify(response.data.response)
        );
      } else {
        console.log("Failed to get user access");
      }
    } catch (error) {
      console.log("Error:", error);
    }
  };
  const subscriptionDetailsApi = async (userId) => {
    try {

      const responseBody = {
        userid: userId,
      };
      const response = await axios.post(
        `${baseUrl}/api/Entitlement/fetchSubscriptionDetails`,
        responseBody,
        config
      );
      if (response.data.responseCode === "00") {
        sessionStorage.setItem("power", "1");
        if (process.env.NODE_ENV == "development") {
          window.location.href = "/Dashboard";
        } else {
          window.location.href = "/Dashboard";
        }
      } else if (response.data.responseCode === "03") {
        if (process.env.NODE_ENV == "development") {
          window.location.href = "/Dashboard";
        } else {
          window.location.href = "/Dashboard";
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Main Login function
 const LoginCall = async () => {
  // Basic validation
  if (MobileNumber.length !== 10) {
    toast.error("Invalid Mobile number");
    return;
  }
  if (!password) {
    toast.error("Please enter your password");
    return;
  }

  try {
    const BankData = {
      mobile: MobileNumber,
      password: password,
      latitude: latitude || "",
      longitude: longitude || "",
    };

    const response = await axios.post(
      `${baseUrl}/api/User/v2.0/userLogin`,
      BankData,
      config2
    );

    if (response.data.responseCode === "00") {
      sessionStorage.setItem("user", JSON.stringify(response.data.response));
      setUser(true);
      await subscriptionDetailsApi(response.data.response.userid);
      await allowedServicesAPI(response.data.response.userid);
      window.location.href = "/Dashboard";
    } else {
      toast.error(response.data.responseMessage);
    }
  } catch (error) {
    toast.error("Error during login");
    console.error("Error during login:", error);
  }
};



  const ResendOtp = async (step) => {
    toast.info("Resending OTP...");

    try {

      const BankData = {
        mobile: MobileNumber,
        password: password,
        step: 1,
        otp: Otp.join(""),
        latitude: latitude,
        longitude: longitude,
      };

      const response = await axios.post(
        `${baseUrl}/api/User/v1/userLogin`,
        BankData,
        config2
      );
      if (step === "1") {
        toast.success(response.data.responseMessage);

        setUser(response.data.response);
        setstep(2);
        setOTPField(true);
      } else if (step === "2") {
        setUser(response.data.response);

        sessionStorage.setItem("power", "1");
        if (process.env.NODE_ENV == "development") {
          window.location.href = "/Dashboard";
        } else {
          window.location.href = "/Dashboard";
        }

      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      toast.error("Error");
      console.error("Error updating Admin login:", error);
    }
  };

  const handleOtpChange = (element, index) => {
    if (isNaN(element.value)) return false;

    const newOtp = [...Otp];
    newOtp[index] = element.value;
    setOtp(newOtp);

    // Move to next input if value is entered
    if (element.value !== "" && element.nextSibling) {
      element.nextSibling.focus();
    }
  };

  const handleKeyDown = (e, index) => {

    if (e.key === "Backspace") {
      e.preventDefault();
      const newOtp = [...Otp];
      newOtp[index] = "";
      setOtp(newOtp);

      // Move to previous input if current is empty
      if (index > 0) {
        const prevInput = e.target.previousSibling;
        prevInput.focus();
      }
    }
  };

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLatitude(position.coords.latitude);
          setLongitude(position.coords.longitude);
        },
        (err) => {
          setLerror(err.message);
        }
      );
    } else {
      setError("Geolocation is not supported by your browser");
    }
  }, []);
  const [ForgetNumber, setForgetNumber] = useState('');
  const [ForgetStep, setForgetStep] = useState(1);
  const [NewPassword, setNewPassword] = useState("");
  const [ConfirmNewPassword, setConfirmNewPassword] = useState("");
  const [ForgetOtp, setForgetOtp] = useState(["", "", "", "", "", ""]);

  const handleForgotOtpChange = (element, index) => {
    if (isNaN(Number(element.value))) return;

    const newOtp = [...ForgetOtp]; // Corrected the reference
    newOtp[index] = element.value;
    setForgetOtp(newOtp);

    // Move to next input if value is entered
    if (element.value !== "" && element.nextElementSibling) {
      element.nextElementSibling.focus();
    }

    // Move to previous input on backspace
    if (element.value === "" && element.previousElementSibling) {
      element.previousElementSibling.focus();
    }
  };
  const sendForgetOtp = async () => {
    try {
      const BankData = {
        mobile: ForgetNumber,
        newPassword: "",
        otp: "",
        step: "1", // Step 1: Send OTP
      };

      const response = await axios.post(
        `${baseUrl}/api/User/v1.0/forgetPassword`,
        BankData,
        config2
      );

      if (response.data.responseCode === "00") {
        toast.success(response.data.responseMessage);
        setLoginScreen("OTPVERIFICATIONFORGET");
        setForgetStep(2); // Move to OTP Verification step
      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      toast.error("Error sending OTP");
      console.error("Error sending OTP:", error);
    }
  };
  const verifyForgetOtp = async () => {
    try {

      const BankData = {
        mobile: ForgetNumber,
        newPassword: "",
        otp: ForgetOtp.join(""),
        step: "2", 
      };

      const response = await axios.post(
        `${baseUrl}/api/User/v1.0/forgetPassword`,
        BankData,
        config2
      );

      if (response.data.responseCode === "00") {
        toast.success(response.data.responseMessage);
        setLoginScreen("RESET_PASSWORD");
        setForgetStep(3);
      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      toast.error("Error verifying OTP");
      console.error("Error verifying OTP:", error);
    }
  };
  const resetPassword = async () => {
    if (NewPassword !== ConfirmNewPassword) {
      toast.error("Passwords do not match");
      return;
    }

    try {

      const BankData = {
        mobile: ForgetNumber,
        newPassword: NewPassword,
        otp: ForgetOtp.join(""),
        step: "3", // Step 3: Reset Password
      };

      const response = await axios.post(
        `${baseUrl}/api/User/v1.0/forgetPassword`,
        BankData,
        config2
      );

      if (response.data.responseCode === "00") {
        toast.success("Password reset successfully!");
        setLoginScreen("LOGIN"); 
      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      toast.error("Error resetting password");
      console.error("Error resetting password:", error);
    }
  };

  function ForgotPassWord() {
    setLoginScreen("FORGOTPASSWORD")
  }
const handleGoogleResponse = async (response) => {
    try {
      const credential = response.credential;
      if (!credential) return;


      const base64Url = credential.split(".")[1];
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const decodedData = JSON.parse(atob(base64));

      const googleUser = {
        name: decodedData.name,
        email: decodedData.email,
        picture: decodedData.picture,
        google_id: decodedData.sub, // IMPORTANT
      };

      const [firstName, ...rest] = googleUser.name.split(" ");
      const lastName = rest.join(" ");

      const basicAuth = btoa("BUMPPY_SSO_SgLjvARJ5LbX:tGhAlPHEkx1McBnkw43vXUXs44i744jQbbjU1ODHB5SIRtSDFYaYF1yeGFJBYlZq");

      const registerResponse = await fetch(
        "https://auth.seobix.com/api/Auth/register2",
        {
          method: "POST",
          headers: {
            "Accept": "*/*",
            "Content-Type": "application/json",
            "Authorization": `Basic ${basicAuth}`,
          },
          body: JSON.stringify({
            username: googleUser.email,
            password: googleUser.google_id, 
            firstName:googleUser.name,
            lastName:googleUser.name,
            dob: "",
            gender: "",
            country: "91",
            latitude: "",
            longitude: "",
            device: "web",
            callback: "",
            productId: "9",
            login_with: "google",
            google_id: googleUser.google_id,
            display_img:googleUser.picture,
          }),
        }
      );

      const registerData = await registerResponse.json();
      console.log("Register API:", registerData);

      // API returns 200 but status=401 in body
      if (registerData.status === "401") {
        console.warn("User already exists or unauthorized, continuing login");
      }

      // =========================
      //  IDENTITY / LOGIN API
      // =========================
      const identityResponse = await fetch(
        "https://auth.seobix.com/api/Auth/identityGoogle",
        {
          method: "POST",
          headers: {
            "Accept": "*/*",
            "Content-Type": "application/json-patch+json",
             "Authorization": `Basic ${basicAuth}`,
          },
          body: JSON.stringify({
            email: googleUser.email,
            latitude: null,
            longitude: null,
            device: "web",
            country: "+91",
            productId: "9",
            callback: null,
          }),
        }
      );

      const identityData = await identityResponse.json();
      console.log("Identity API:", identityData);


      localStorage.setItem("accessToken", identityData.accessToken);
      localStorage.setItem("refreshToken", identityData.refreshToken);
      localStorage.setItem("userId", identityData.userId);


      if (window.google?.accounts?.id) {
        window.google.accounts.id.cancel();
      }

      const urlParams = new URLSearchParams(window.location.search);
      const callbackUrl = urlParams.get("callback");

      if (callbackUrl && identityData?.accessToken) {
        const url = new URL(callbackUrl);

        url.searchParams.set("accessToken", identityData.accessToken);



        window.location.href = url.toString();
      }

    } catch (err) {
      console.error("Google Login Error:", err);
    }
  };
  return (
    <div className="anlook-container">
  <div className="login-wrapper">
    <NoIndex />
    <ToastContainer position="top-center" />

    <div className="login-card">
      <div className="login-header">
        <img src={LogoImage} alt="logo" className="login-logo" />
        <h2>Welcome to Sendbulkmsg</h2>
        <p>
          {LoginScreen === "LOGIN" && "Login with your mobile number"}
          {LoginScreen === "OTPVERIFICATION" && "Enter OTP sent to your mobile"}
          {LoginScreen === "FORGOTPASSWORD" && "Reset your password"}
        </p>
      </div>

      {/* ================= LOGIN ================= */}
      {LoginScreen === "LOGIN" && (
        <>
          <div className="input-group-modern">
            <span className="country-code">+91</span>
            <input
              type="tel"
              placeholder="Mobile number"
              value={MobileNumber}
              onChange={(e) => setMobileNumber(e.target.value)}
            />
          </div>

          <div className="input-group-modern">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          <div className="login-options">
            <label>
              <input
                type="checkbox"
                className="mx-2"
                checked={showPassword}
                onChange={togglePasswordVisibility}
              />
              Show password
            </label>

            <span
              className="link-text"
              onClick={() => setLoginScreen("FORGOTPASSWORD")}
            >
              Forgot password?
            </span>
          </div>

          <button className="primary-btn" onClick={validateInputs}>
            Continue
          </button>
        </>
      )}
<div className="mt-1">
                    <GoogleOneTap onSuccess={handleGoogleResponse} />
                  </div>
      {/* ================= OTP LOGIN ================= */}
      {LoginScreen === "OTPVERIFICATION" && (
        <>
          <div className="otp-box">
            {Otp.map((v, i) => (
              <input
                key={i}
                maxLength="1"
                value={v}
                onChange={(e) => handleOtpChange(e.target, i)}
                onKeyDown={(e) => handleKeyDown(e, i)}
              />
            ))}
          </div>

          <button className="primary-btn" onClick={verifyOtp}>
            Verify OTP
          </button>

          <button className="secondary-btn" onClick={ResendOtp}>
            Resend OTP
          </button>
        </>
      )}

      {/* ================= FORGOT PASSWORD ================= */}
      {LoginScreen === "FORGOTPASSWORD" && (
        <>
          <div className="input-group-modern">
            <span className="country-code">+91</span>
            <input
              type="tel"
              placeholder="Registered mobile number"
              value={ForgetNumber}
              onChange={(e) => setForgetNumber(e.target.value)}
            />
          </div>

          <button className="primary-btn" onClick={sendForgetOtp}>
            Send OTP
          </button>

          <button
            className="secondary-btn"
            onClick={() => setLoginScreen("LOGIN")}
          >
            Back to login
          </button>
        </>
      )}

      {/* ================= FORGOT OTP ================= */}
      {LoginScreen === "OTPVERIFICATIONFORGET" && (
        <>
          <div className="otp-box">
            {ForgetOtp.map((v, i) => (
              <input
                key={i}
                maxLength="1"
                value={v}
                onChange={(e) => handleForgotOtpChange(e.target, i)}
              />
            ))}
          </div>

          <button className="primary-btn" onClick={verifyForgetOtp}>
            Verify OTP
          </button>
        </>
      )}

      {/* ================= RESET PASSWORD ================= */}
      {LoginScreen === "RESET_PASSWORD" && (
        <>
          <div className="input-group-modern">
            <input
              type="password"
              placeholder="New password"
              value={NewPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
          </div>

          <div className="input-group-modern">
            <input
              type="password"
              placeholder="Confirm new password"
              value={ConfirmNewPassword}
              onChange={(e) => setConfirmNewPassword(e.target.value)}
            />
          </div>

          <button className="primary-btn" onClick={resetPassword}>
            Reset Password
          </button>
        </>
      )}
    </div>
  </div>
    </div>
  );

};

export default LoginPage;